import React from 'react'
import { I18nComponentType } from 'interview/i18n-types'
import { mapLanguageToComponentProps } from 'interview/i18n'
import { connect } from 'react-redux'
import { LabelledInput } from 'components/form-components/styled-text-input/with-label'
import styled from 'styled-components'
import { Flex } from 'components/styled/containers/flex'
import { validators } from 'utils/form'
import validator from 'validator'

const { isRequired, isEmail } = validators

interface CandidateInfoFormProps {
  hasCandidateInfo: boolean
  i18n: I18nComponentType
  onChange: (model: string, value: any) => void
}

const FormContainer = styled(Flex)`
  width: 100%;
  gap: ${({ theme }) => theme.space.s16};

  > * {
    width: 50%;
  }

  ${({ theme }) => theme.mediaQuery.phone} {
    flex-direction: column;
    gap: 0;

    > * {
      width: 100%;
    }
  }
`

function addProtocol(value: string) {
  return value.length === 0 || value.startsWith('http')
    ? value
    : `http://${value}`
}

export const CandidateInfoForm = ({
  hasCandidateInfo,
  onChange,
  i18n,
}: CandidateInfoFormProps) => {
  const onChangeLink = (model: string, value: string) => {
    if (value.length === 0 || value === 'http://' || value === 'https://') {
      onChange(model, '')
      return
    }

    const linkValue = addProtocol(value)
    onChange(model, linkValue)
  }

  return (
    <>
      {!hasCandidateInfo && (
        <FormContainer flexDirection="row">
          <LabelledInput
            title={i18n.interviewForm.email}
            placeholder={i18n.interviewForm.placeholderEmail}
            isRequired
            model="candidate.email"
            validators={{ isRequired, isEmail }}
            validateOn="change"
            type="email"
            autoComplete="off"
          />
          <LabelledInput
            title={i18n.interviewForm.link}
            model="candidate.link"
            type="text"
            maxLength={200}
            autoComplete="off"
            validators={{
              invalidUrl: (value: string) =>
                value.length === 0 ||
                validator.isURL(addProtocol(value), {
                  protocols: ['http', 'https'],
                  require_protocol: true,
                }),
            }}
            validateOn="change"
            placeholder={i18n.interviewForm.placeholderLink}
            // @ts-ignore what is the issue here? TODO fix type
            changeAction={(model, value) => onChangeLink(model, value)}
          />
        </FormContainer>
      )}
    </>
  )
}

export default connect(mapLanguageToComponentProps())(CandidateInfoForm)
